<template>
  <refund-list
    @downloadReport="downloadReport($event)"
    @loadData="loadData($event)"
    @searchByDispatchId="searchByDispatchId($event)"
    @createChargeRefund="createChargeRefund($event)"
    :charge="charge"
    :refunds="refunds"
    :refundState="refundState"
    :loadingCharge="loadingCharge"
    :refundsLoading="refundsLoading"
    :selectedLanguage="selectedLanguage"
    :reportGenerating="reportGenerating"
    :totalRefunds="totalCount"
  ></refund-list>
</template>

<script>
import RefundList from '../../components/RefundList.vue';
import dayjs from '../../plugins/dayjs';
import { listRefunds } from '../../mixins/refunds.mixins';
import { languageMethods, languageComputed } from '../../mixins/language.mixins';
import { csvReport } from '../../mixins/csvReport.mixins';
import { download } from '../../mixins/download.mixins';

export default {
  name: 'list-refund-view',
  components: { RefundList },
  mixins: [
    csvReport,
    download,
    listRefunds,
    languageMethods,
    languageComputed,
  ],
  data: () => ({
    charge: null,
  }),
  computed: {
    totalCount() {
      return this.refundsListInfo.totalCount;
    },
  },
  methods: {
    async searchByDispatchId({
      dispatchId,
    }) {
      const refundsSearchObject = {
        page: 0,
        maxPerPage: 1,
        dispatchId,
      };
      const { data } = await this.searchChargesByDispatchId(refundsSearchObject);
      if (data[0]) {
        this.charge = data[0];
      } else {
        this.charge = null;
      }
    },

    async createChargeRefund({ chargeId, refundAmount }) {
      const { errorCode } = await this.refundCharge({ chargeId, refundAmount });
      if (!errorCode) {
        this.charge = null;
        await this.listRefunds();
      }

    },

    async loadData({
      sort, page, maxPerPage, startDate, endDate, dateType, dynamicSearch,
    }) {
      this.refundsSearchObject = {
        page,
        maxPerPage,
        sort,
        dateType,
        startDate,
        endDate,
        dynamicSearch,
      };
      await this.listRefunds();
    },


    async downloadReport({ startDate, endDate, dateType, sort }) {
      const filename = `${this.$t(
        'pages.refund.list.filenamePrefix',
      )}-${dayjs().format('YYYY-MM-DD_HHmmss')}.csv`;
      this.reportRefundGenerationObject = {
        filename,
        startDate,
        endDate,
        dateType,
        sort,
      };

      const result = await this.generateRefundReport();

      if (!result.errorCode) {
        this.download({ data: this.reportData, filename });
      }
    },
  },
};
</script>
